import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cc1d0ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animated" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Voltar ao feed ")
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center py-10"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hollow-dots-spinner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "text-center py-10 text-muted"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question-circle fs-3x d-block mb-3" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Caso não encontrado", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Voltar ao feed")
const _hoisted_11 = {
  key: 2,
  class: "row"
}
const _hoisted_12 = { class: "col-lg-8" }
const _hoisted_13 = { class: "d-flex align-items-center gap-2 mb-2" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "fs-2 mb-4" }
const _hoisted_16 = {
  key: 0,
  class: "card mb-6"
}
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock-history text-warning me-1" }),
  /*#__PURE__*/_createTextVNode(" Linha do tempo")
], -1))
const _hoisted_20 = { class: "timeline" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line" }, null, -1))
const _hoisted_22 = { class: "timeline-icon" }
const _hoisted_23 = { class: "timeline-content mb-8" }
const _hoisted_24 = { class: "d-flex align-items-center gap-2 fs-8 text-muted mb-1" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 2,
  class: "badge badge-light-warning py-0"
}
const _hoisted_28 = { class: "mb-2" }
const _hoisted_29 = ["href"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-up-right fs-8" }, null, -1))
const _hoisted_31 = {
  key: 0,
  class: "alert alert-light-primary d-flex p-3 mb-2"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-stars text-primary me-2 mt-1" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-8 text-uppercase text-primary mb-1" }, "O que este artigo acrescentou", -1))
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_39 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-files text-muted me-1" }),
  /*#__PURE__*/_createTextVNode(" Também cobriram (sem novidade)")
], -1))
const _hoisted_41 = { class: "d-flex flex-column gap-2" }
const _hoisted_42 = ["href"]
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "text-truncate" }
const _hoisted_45 = { class: "fs-8 text-muted ms-auto flex-shrink-0" }
const _hoisted_46 = { class: "col-lg-4" }
const _hoisted_47 = { class: "card mb-6" }
const _hoisted_48 = { class: "card-body p-4" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-3" }, "Estatísticas", -1))
const _hoisted_50 = { class: "row g-2 text-center" }
const _hoisted_51 = { class: "col-6" }
const _hoisted_52 = { class: "fs-3 fw-bold" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted" }, "artigos", -1))
const _hoisted_54 = { class: "col-6" }
const _hoisted_55 = { class: "fs-3 fw-bold text-primary" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted" }, "com novidade", -1))
const _hoisted_57 = { class: "col-6" }
const _hoisted_58 = { class: "fs-3 fw-bold" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted" }, "fontes", -1))
const _hoisted_60 = { class: "col-6" }
const _hoisted_61 = { class: "fs-3 fw-bold text-muted" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted" }, "repetições", -1))
const _hoisted_63 = {
  key: 0,
  class: "mt-3 pt-3 border-top text-muted fs-8"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar-event me-1" }, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-download me-1" }, null, -1))
const _hoisted_66 = {
  key: 0,
  class: "card mb-6"
}
const _hoisted_67 = { class: "card-body p-4" }
const _hoisted_68 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-fingerprint text-warning me-1" }),
  /*#__PURE__*/_createTextVNode(" Indicadores")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IndicatorGroups = _resolveComponent("IndicatorGroups")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/apps/quimerax-news",
      class: "btn btn-sm btn-light-primary mb-4"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : (_ctx.notFound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createVNode(_component_router_link, { to: "/apps/quimerax-news" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]))
        : (_ctx.detail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.normalizeCriticity(_ctx.detail.criticity))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(`badge badge-${_ctx.criticityColor(_ctx.detail.criticity)}`)
                      }, _toDisplayString(_ctx.normalizeCriticity(_ctx.detail.criticity)), 3))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.victim_sectors, (sector) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: sector,
                      class: "badge badge-light-info cursor-pointer",
                      onClick: ($event: any) => (_ctx.goToFeed('victim_sectors', sector))
                    }, _toDisplayString(sector), 9, _hoisted_14))
                  }), 128))
                ]),
                _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.detail.title), 1),
                (_ctx.detail.latest_summary)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", {
                          class: "trf-markdown",
                          innerHTML: _ctx.renderMarkdown(_ctx.detail.latest_summary)
                        }, null, 8, _hoisted_18)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timelineItems, (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "timeline-item"
                    }, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("i", {
                          class: _normalizeClass(item.isFirst ? 'bi bi-flag-fill text-warning' : 'bi bi-arrow-up-circle-fill text-primary')
                        }, null, 2)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          (item.entry.source_host)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: `https://www.google.com/s2/favicons?sz=32&domain=${item.entry.source_host}`,
                                style: {"width":"16px","height":"16px"},
                                alt: ""
                              }, null, 8, _hoisted_25))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(item.entry.source_host), 1),
                          (item.entry.published_at)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, "· pub. " + _toDisplayString(_ctx.formatDate(item.entry.published_at)), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, "· coletado " + _toDisplayString(_ctx.formatDateTime(item.entry.collected_at)), 1),
                          (item.isFirst)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, "primeiro registro"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("h5", _hoisted_28, [
                          _createElementVNode("a", {
                            href: item.entry.news_url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: "text-gray-900 text-hover-primary"
                          }, [
                            _createTextVNode(_toDisplayString(item.entry.title) + " ", 1),
                            _hoisted_30
                          ], 8, _hoisted_29)
                        ]),
                        (item.entry.new_context)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _hoisted_32,
                              _createElementVNode("div", null, [
                                _hoisted_33,
                                _createElementVNode("div", {
                                  class: "trf-markdown",
                                  innerHTML: _ctx.renderMarkdown(item.entry.new_context)
                                }, null, 8, _hoisted_34)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (item.entry.summary)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "trf-markdown text-gray-700",
                              innerHTML: _ctx.renderMarkdown(item.entry.summary)
                            }, null, 8, _hoisted_35))
                          : _createCommentVNode("", true),
                        (item.indicatorCount)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _createElementVNode("a", {
                                href: "#",
                                class: "fs-8 text-muted",
                                onClick: _withModifiers(($event: any) => (item.showIndicators = !item.showIndicators), ["prevent"])
                              }, _toDisplayString(item.showIndicators ? "ocultar" : "ver") + " " + _toDisplayString(item.indicatorCount) + " indicadores ", 9, _hoisted_37),
                              (item.showIndicators)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createVNode(_component_IndicatorGroups, {
                                      groups: item.entry.indicators,
                                      onFilter: _ctx.goToFeed
                                    }, null, 8, ["groups", "onFilter"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]),
                (_ctx.detail.no_update_sources.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("div", _hoisted_41, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.no_update_sources, (s, i) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: i,
                            href: s.news_url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: "d-flex align-items-center gap-2 text-gray-700 text-hover-primary text-decoration-none"
                          }, [
                            (s.source_host)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: `https://www.google.com/s2/favicons?sz=32&domain=${s.source_host}`,
                                  style: {"width":"16px","height":"16px"},
                                  alt: ""
                                }, null, 8, _hoisted_43))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_44, _toDisplayString(s.title), 1),
                            _createElementVNode("span", _hoisted_45, _toDisplayString(s.source_host) + " · " + _toDisplayString(_ctx.formatDate(s.collected_at)), 1)
                          ], 8, _hoisted_42))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.detail.stats.total_docs), 1),
                        _hoisted_53
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.detail.stats.new_info_count), 1),
                        _hoisted_56
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.detail.stats.source_count), 1),
                        _hoisted_59
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.detail.stats.no_update_count), 1),
                        _hoisted_62
                      ])
                    ]),
                    (_ctx.publishedRange)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _createElementVNode("div", null, [
                            _hoisted_64,
                            _createTextVNode(" Publicado: " + _toDisplayString(_ctx.publishedRange), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_65,
                            _createTextVNode(" Coletado: " + _toDisplayString(_ctx.formatDate(_ctx.detail.stats.first_collected_at)) + " – " + _toDisplayString(_ctx.formatDate(_ctx.detail.stats.last_collected_at)), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.detail.indicators.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _hoisted_69,
                          _createElementVNode("a", {
                            href: "#",
                            class: "fs-8 text-muted",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showAllIndicators = !_ctx.showAllIndicators), ["prevent"]))
                          }, _toDisplayString(_ctx.showAllIndicators ? "recolher" : "expandir"), 1)
                        ]),
                        _createVNode(_component_IndicatorGroups, {
                          groups: _ctx.detail.indicators,
                          collapsed: !_ctx.showAllIndicators,
                          onFilter: _ctx.goToFeed
                        }, null, 8, ["groups", "collapsed", "onFilter"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}